import { useEffect } from 'react';
import { useExplainerCardsStore } from '@/stores/explainerCards/explainerCardsStore';
import { getExplainerCardsDismissed, dismissExplainerCard } from '@/services/user.service';

// Module-level set prevents duplicate in-flight fetches when multiple components
// on the same page call useExplainerCard with the same kbId
const fetchingKbIds = new Set();

const useExplainerCard = (cardName, kbId) => {
  const dismissedByKbId = useExplainerCardsStore((state) => state.dismissedByKbId);
  const fetchedKbIds = useExplainerCardsStore((state) => state.fetchedKbIds);
  const setFetchedCards = useExplainerCardsStore((state) => state.setFetchedCards);
  const dismissCard = useExplainerCardsStore((state) => state.dismissCard);

  const isFetched = kbId ? fetchedKbIds[kbId] === true : true;
  const isDismissed = kbId ? dismissedByKbId[kbId]?.[cardName] === true : true;

  useEffect(() => {
    if (!kbId || isFetched || fetchingKbIds.has(kbId)) return;

    fetchingKbIds.add(kbId);

    getExplainerCardsDismissed(kbId)
      .then((response) => {
        setFetchedCards(kbId, response.data || {});
      })
      .catch(() => {
        setFetchedCards(kbId, {});
      })
      .finally(() => {
        fetchingKbIds.delete(kbId);
      });
  }, [kbId, isFetched]);

  const dismiss = async () => {
    dismissCard(kbId, cardName);
    try {
      await dismissExplainerCard(kbId, cardName);
    } catch {
      // fail silently - UI already dismissed
    }
  };

  return { isVisible: !isDismissed, dismiss };
};

export default useExplainerCard;
